import { DEFAULT_EMPTY_VALUE } from './constants';
import type { Column } from './types';

interface ValueCellProps<TData extends Record<string, any>> {
	column: Column<TData>;
	data: TData;
}

export const ValueCell = <TData extends Record<string, any>>({
	column,
	data,
}: ValueCellProps<TData>) => {
	const raw = data[column.id];

	return (
		<td className="font-bold">
			{typeof column.valueFormatter === 'function'
				? column.valueFormatter({ value: raw, data })
				: (raw ?? DEFAULT_EMPTY_VALUE)}
		</td>
	);
};
